import { signupFormWithAnalyticsSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import * as z from "zod/v4";

export const unpublishSignupForm = {
  name: "unpublishSignupForm" as const,
  input: z.object({ formId: z.string(), form: signupFormWithAnalyticsSchema }),
  output: z.literal("success"),
};
